import GET_CLIENT_SUMMARY from './clientSummary.graphql'

export default GET_CLIENT_SUMMARY
